import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import { useAuth } from "../../context/AuthContext";
import Fade from "react-reveal/Fade";
import MuiPhoneNumber from "material-ui-phone-number";

import TextField from "@mui/material/TextField";
import LeftMenu from "./LeftMenu";
import { db, doc, setDoc, getDoc } from "../../firebase";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  body: { backgroundColor: "white", minHeight: "500px", padding: "50px" },
  title: { fontSize: "16px" },
});

const Dashboard = () => {
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  const {
    currentUser,
    updateUserEmail,
    firstname,
    lastname,
    getPhone,
    setFirstnameByFunction,
    setLastnameByFunction,
    setPhone,
    getFirstname,
    getLastname,
  } = useAuth();

  const [email, setEmail] = useState(currentUser.email || "");
  const [newPhone, setNewPhone] = useState("");
  const [fn, setFn] = useState("");
  const [ln, setLn] = useState("");
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");
  const changePhoneNumber = (value) => {
    setNewPhone(value);
  };
  // console.log("getPhone", getPhone());
  useEffect(() => {
    const getUser = async () => {
      const docRef = doc(db, "users", currentUser.uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        console.log("Document data:", docSnap.data());
        setFn(docSnap.data().firstname.toUpperCase());
        setLn(docSnap.data().lastname.toUpperCase());
        setNewPhone(docSnap.data().phone);
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
    };
    getUser();
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    console.log(email);

    if (email.length > 3) {
      updateUserEmail(email);
    }
    if (newPhone) {
      setDoc(
        doc(db, "users", currentUser.uid),
        {
          firstname: fn,
          lastname: ln,
          phone: newPhone,
        },
        { merge: true }
      );
    } else {
      setDoc(
        doc(db, "users", currentUser.uid),
        {
          firstname: fn,
          lastname: ln,
        },
        { merge: true }
      );
    }

    setFirstnameByFunction(fn);
    setLastnameByFunction(ln);
    setPhone(newPhone);

    setError("");
    setLoading(false);
  };

  return (
    <Grid
      container
      sx={{
        px: { md: 10, sm: 5 },
        pt: 7,
        pb: 20,
        backgroundColor: "#eceff1",
      }}
    >
      <Grid item sm={12} md={12} sx={{ fontSize: "19px", pb: 2, pl: 2 }}>
        <Box>{t("MY ACCOUNT")}</Box>
      </Grid>

      <LeftMenu cursor="personal" />
      <Grid md={9} sm={12} className={classes.body}>
        <Box className={classes.title}>
          <Fade delay={300}>
            <Box sx={{ fontWeight: 600, fontSize: "17px", pb: 5 }}>
              <Fade delay={300}>{t("Change your personal information")}</Fade>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Box sx={{ display: "flex" }}>
                <TextField
                  required
                  fullWidth
                  id="lastName"
                  label={t("Last Name")}
                  name="lastName"
                  value={ln}
                  autoComplete="family-name"
                  onChange={(e) => setLn(e.target.value)}
                  sx={{ width: 1 / 2, mr: 2, fontSize: "14px" }}
                />
                <TextField
                  autoComplete="given-name"
                  required
                  fullWidth
                  label={t("First Name")}
                  autoFocus
                  value={fn}
                  onChange={(e) => setFn(e.target.value)}
                  sx={{ width: 1 / 2, ml: 2, fontSize: "14px" }}
                />
              </Box>
              <Box sx={{ display: "flex", pt: 3 }}>
                <TextField
                  required
                  fullWidth
                  id="email"
                  label={t("Email Address")}
                  name="email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  sx={{ width: 1 / 2, mr: 2, fontSize: "14px" }}
                />
                <Box
                  sx={{
                    width: 1 / 2,
                    ml: 2,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ pr: 2, fontSize: "14px" }}>{t("Phone")}:</Box>
                  <MuiPhoneNumber
                    value={newPhone}
                    regions={"asia"}
                    defaultCountry={"kr"}
                    onChange={changePhoneNumber}
                    style={{ flex: 1 }}
                  />
                </Box>
              </Box>
              <button
                onClick={handleSubmit}
                className="custom_btn"
                style={{
                  marginTop: "40px",
                  width: "240px",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                {loading ? (
                  <span>{t("Processing")}...</span>
                ) : (
                  <span>{t("Update")}</span>
                )}
              </button>
              {/* <TextField
								fullWidth
								name="password"
								label="Leave blank to keep the same password"
								type="password"
								id="password"
								autoComplete="new-password"
								onChange={(e) => setPass(e.target.value)}
								sx={{ width: 1 / 2, ml: 2 }}
							/> */}
            </Box>
          </Fade>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Dashboard;
